import React from 'react'
import { makeStyles } from '@material-ui/styles'
import { Skeleton } from '@material-ui/lab'
import DazzedParagraph16 from '../../common/text/DazzedParagraph16'
import { isMobile } from 'react-device-detect'
import DazzedHeading36 from '../../common/text/DazzedHeading36'

const useStyles = makeStyles(
  theme => ({
    root: {
      textAlign: ({ isMobile }) => (isMobile ? 'start!important' : 'center!important'),
      padding: ({ isMobile }) => (isMobile ? '0 20px' : 0)
    },
    index: {
      fontSize: '40px',
      fontWeight: 'normal',
      marginBottom: 8
    },
    skeletonLine: {
      height: 20,
      borderRadius: 4
    },
    skeletonLineCentered: {
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  }),
  { isMobile }
)

const OnboardingStepText = ({ text, index, isLoading = false }) => {
  const classes = useStyles({ isMobile })

  return (
    <div className={classes.root}>
      <DazzedHeading36 className={classes.index}>0{index}</DazzedHeading36>
      {isLoading ? (
        <>
          <Skeleton
            variant="text"
            width={isMobile ? '90%' : '80%'}
            className={`${classes.skeletonLine} ${!isMobile ? classes.skeletonLineCentered : ''}`}
          />
          <Skeleton
            variant="text"
            width={isMobile ? '70%' : '60%'}
            className={`${classes.skeletonLine} ${!isMobile ? classes.skeletonLineCentered : ''}`}
          />
        </>
      ) : (
        <DazzedParagraph16 textAlign={isMobile ? 'start' : 'center'}>{text}</DazzedParagraph16>
      )}
    </div>
  )
}

export default OnboardingStepText
